import React, { useState } from 'react';
import { Button, Col, Form, Modal, Row, Select } from 'antd';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { setRefetch } from '../../redux/slices/menu';
import merchantService from '../../services/merchant';
import { toast } from 'react-toastify';
import TextArea from 'antd/es/input/TextArea';

const statuses = ['new', 'approved', 'rejected', 'cancelled'];

export default function MerchantStatusModal({ data, handleCancel }) {
  const { t } = useTranslation();
  const { activeMenu } = useSelector((state) => state.menu, shallowEqual);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const onFinish = (values) => {
    setLoading(true);

    const body = {
      status: values?.status,
      status_note: values?.status_note ?? '',
    };

    merchantService
      .statusChange(data?.uuid, body)
      .then(() => {
        toast.success(t('successfully.updated'), { autoClose: 10000 });
        handleCancel();
        dispatch(setRefetch(activeMenu));
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || t('error.occurred'), {
          autoClose: 10000,
        });
      })
      .finally(() => setLoading(false));
  };

  return (
    <Modal
      visible={!!data}
      title={data?.name ?? t('merchant')}
      onCancel={handleCancel}
      footer={[
        <Button
          key='save'
          type='primary'
          onClick={() => form.submit()}
          loading={loading}
        >
          {t('save')}
        </Button>,
        <Button key='cancel' type='default' onClick={handleCancel}>
          {t('cancel')}
        </Button>,
      ]}
    >
      <Form
        form={form}
        layout='vertical'
        onFinish={onFinish}
        initialValues={{
          status: data?.status ?? 'new',
          status_note: data?.status_note ?? '',
        }}
      >
        <Row gutter={12}>
          <Col span={24}>
            <Form.Item
              label={t('status')}
              name='status'
              rules={[
                {
                  required: true,
                  message: t('required'),
                },
              ]}
            >
              <Select>
                {statuses.map((item, idx) => (
                  <Select.Option key={item + idx} value={item}>
                    {t(item)}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label={t('status.note')} name='status_note'>
              <TextArea rows={3} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
